// extracted by mini-css-extract-plugin
export default {"actionBtn":"MonitorMenu_actionBtn__kSR7M"};